import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import DetailRateForm from "@/components/detail/DetailRateForm";
import Section from "@/components/helpers/Section/Section.tsx";

import { ROUTES } from "@/config/routes.ts";

const DetailRatePage = (): JSX.Element => {
  const { t } = useTranslation();
  const { id } = useParams() as { id: string };

  return (
    <Section title={t("General.rate-and-reviews")} backUrl={ROUTES.DETAIL.MAIN.replace(":id", id)} className={"mt-5"}>
      <DetailRateForm goBack={true} />
    </Section>
  );
};

export default DetailRatePage;
